"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.country = void 0;
const types_1 = require("../../types");
const { CountryEnum } = types_1.Vehicle;
exports.country = [
    {
        id: CountryEnum.US,
        name: 'United States',
        value: ['US'],
    },
    {
        id: CountryEnum.CA,
        name: 'Canada',
        value: ['CA'],
    },
    {
        id: CountryEnum.MX,
        name: 'Mexico',
        value: ['MX'],
    },
    {
        id: CountryEnum.Europe,
        name: 'Europe',
        value: ['AT', 'BE', 'DE', 'ES', 'FR', 'GB', 'HU', 'IT', 'TR', 'SE', 'ZA'],
    },
    {
        id: CountryEnum.Asia,
        name: 'Asia',
        value: ['CN', 'JP', 'KR', 'TH', 'TW'],
    }
];
